import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
import { MenuModel } from '../menu/menu.model';
export class ButtonMenuModel extends CoreModel {
/**
 * <p>The button object from Button Model</p>
 */
buttonProperty: ButtonModel;
/**
 * <p>The menu object from Menu Model</p>
 */
menuProperty: MenuModel;
/**
 * @hidden 
 * It is the constructor for the button menu component. It takes the required string values to create the button menu object
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ButtonMenuModel_tsickle_Closure_declarations() {
/**
 * <p>The button object from Button Model</p>
 * @type {?}
 */
ButtonMenuModel.prototype.buttonProperty;
/**
 * <p>The menu object from Menu Model</p>
 * @type {?}
 */
ButtonMenuModel.prototype.menuProperty;
}

